// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3dbUd","consentsList":"PatientConsents_consentsList__3nYkS","consentsListEmpty":"PatientConsents_consentsListEmpty__3NZ5M"};